import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { DesktopSelect } from './desktop';
import { MobileSelect } from './mobile';
const EMPTY_OPTIONS = [];
export function Select({ options, ...props }) {
    const resolvedOptions = (options ?? EMPTY_OPTIONS);
    return (_jsxs(Fragment, { children: [_jsx("div", { className: "hidden sm:block", children: _jsx(DesktopSelect, { ...props, options: resolvedOptions }) }), _jsx("div", { className: "block sm:hidden", children: _jsx(MobileSelect, { ...props, options: resolvedOptions }) })] }));
}
